import { z } from "zod";

export const zUnderlayTransform = z.object({
	x: z.number(),
	y: z.number(),
	rotation: z.number(),
	scale: z.number().positive(),
});

export type UnderlayTransform = z.infer<typeof zUnderlayTransform>;

export const zUnderlayKind = z.enum(["image", "pdf"]);

export type UnderlayKind = z.infer<typeof zUnderlayKind>;

export const zUnderlay = z.object({
	id: z.string().uuid(),
	name: z.string().min(1).max(255),
	kind: zUnderlayKind,
	page: z.number().int().positive().nullable(),
	mmPerUnit: z.number().positive().nullable(),
	transform: zUnderlayTransform,
	opacity: z.number().min(0).max(1),
	locked: z.boolean(),
	onTop: z.boolean(),
	visible: z.boolean(),
	transparentWhite: z.boolean(),
	createdAt: z.string().or(z.date()),
});

export type Underlay = z.infer<typeof zUnderlay>;

export const zUnderlayPatch = zUnderlay
	.pick({
		name: true,
		transform: true,
		opacity: true,
		locked: true,
		onTop: true,
		visible: true,
		transparentWhite: true,
	})
	.partial();

export type UnderlayPatch = z.infer<typeof zUnderlayPatch>;

export const zUnderlayFile = z.enum(["original", "overview", "snap"]);

export type UnderlayFile = z.infer<typeof zUnderlayFile>;
